<template>
    <div class="view login">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card">
                        <div slot="header" class="text-left">
                            <h3>Forgot your password</h3>
                        </div>
                        <p>Please fill in your email address, in case this email address is known in our system we will send you a reset password link</p>
                        <div v-if=successMessage>
                            <b-alert show variant="success">{{ successMessage }}</b-alert>
                        </div>
                        <form class="form-signin" @submit.prevent="submit">
                            <div :class="{ 'hasError': $v.form.email.$error }">
                                <label for="inputEmail" class="sr-only">Email address</label>
                                <input v-model=form.email type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus>
                            </div>
                            <el-button class="btn-block mt-10 mb-10" type="primary" native-type="submit">Send email</el-button>
                        </form>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
    data () {
        return {
            form: { email: '' },
            errorMessage: null,
            successMessage: null

        }
    },

    validations: {
        form: {
            email: { required, email }
        }
    },

    methods: {
        submit () {
            this.errorMessage = null
            this.successMessage = null
            this.$v.form.$touch()
            if (this.$v.form.$error) return

            // All validations passed, so try to log in
            this.$auth.forgotPassword(this.form.email.toLowerCase())
                .then(response => {
                    if (response.status === 200) {
                        this.successMessage = 'In case this email address existed, an email has been sent to your email address.'
                    } else {
                        this.successMessage = 'In case this email address existed, an email has been sent to your email address.'
                    }
                })
                .catch(error => {
                    this.errorMessage = 'Something went wrong, please try again later.'
                    console.log(error)
                })
        }
    }
}
</script>

<style lang="scss">
.forgot-password-page {
    .card-header {
        background-color: #fff;
    }
    .form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
    }
    .form-signin .checkbox {
    font-weight: 400;
    }
    .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
    }
    .form-signin .form-control:focus {
    z-index: 2;
    }
    .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    }
    .form-signin input[type="password"] {
    margin-bottom: 10px;
    margin-top: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    }
}
</style>
